import { Media } from "@/components/layout/Media";
import { RankIcon, RankText } from "@/components/pieces/roleplays/RankIcon";
import { RankMeter } from "@/components/pieces/roleplays/RankMeter";
import { RoleplayRank } from "@/graphql";

interface RankDisplayProps {
  rank: RoleplayRank | null | undefined;
  score: number | null | undefined;
}

export function RankDisplay({ rank, score }: RankDisplayProps) {
  const earnedMedal = rank && rank !== RoleplayRank.Unranked;

  return (
    <div className="flex items-center mt-6 sm:mt-0">
      {earnedMedal ? (
        <Media greaterThan="xs">
          <div className="min-w-[60px]">
            <RankIcon rank={rank} size={50} type="badge" />
          </div>
        </Media>
      ) : null}
      <div className={`w-full mb-3 ${earnedMedal ? "sm:ml-3" : "ml-0"}`}>
        <div className="flex items-center mb-2.5">
          {earnedMedal ? (
            <Media at="xs">
              {(className, renderChildren) =>
                renderChildren && (
                  <div className={`min-w-[30px] mr-2 ${className}`}>
                    <RankIcon rank={rank} size={30} type="circle" />
                  </div>
                )
              }
            </Media>
          ) : null}
          <RankText rank={rank}>
            {rank === "Bronze"
              ? "You earned bronze!"
              : rank === "Silver"
                ? "You earned silver!"
                : rank === "Gold"
                  ? "You earned gold!"
                  : "Try again to earn a medal"}
          </RankText>
        </div>
        <RankMeter score={score} rank={rank} />
      </div>
    </div>
  );
}
